'use client'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { PARTNER_PATHS, PARTNER_PROBLEMS } from '@/data/consulting-partner'

export default function PartnerProblemPicker() {
  const [active, setActive] = useState(0)

  return (
    <div className='cns-problem-picker'>
      <div
        className='cns-problem-list'
        role='group'
        aria-label='Agency delivery situations'
      >
        {PARTNER_PROBLEMS.map((problem, index) => (
          <Button
            key={problem.id}
            className='cns-problem-trigger whitespace-normal no-underline transition-none hover:no-underline focus-visible:ring-0 focus-visible:ring-offset-0'
            variant='link'
            size='link'
            type='button'
            aria-pressed={index === active}
            aria-controls={`problem-panel-${problem.id}`}
            onClick={() => setActive(index)}
          >
            <span>{problem.index}</span>
            <strong>{problem.title}</strong>
            <i aria-hidden='true'>→</i>
          </Button>
        ))}
      </div>

      <div className='cns-problem-output'>
        {PARTNER_PROBLEMS.map((problem, index) => {
          const path = PARTNER_PATHS.find(item => item.id === problem.pathId)

          return (
            <article
              key={problem.id}
              id={`problem-panel-${problem.id}`}
              aria-live={index === active ? 'polite' : undefined}
              hidden={index !== active}
            >
              <span className='cns-label'>Signal / {problem.index}</span>
              <p>{problem.signal}</p>
              <div className='cns-problem-route'>
                <span>Recommended route</span>
                <strong>{problem.recommendation}</strong>
                <a href={`#path-${path?.id ?? 'pilot'}`}>
                  Inspect {path?.tab ?? 'delivery path'}{' '}
                  <i aria-hidden='true'>↓</i>
                </a>
              </div>
            </article>
          )
        })}
      </div>
    </div>
  )
}
